<ng-container>
    <div class="help-video-title">
        <ng-content select="[title]"></ng-content>
    </div>
    <div class="help-video-content">
        <iframe class="video-iframe" [attr.src]="path + (path ? '?modestbranding=1' : '') | safe" title="Digdat Help Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
</ng-container>

